import { Cloud } from "lucide-react";

/**
 * Header deep-links (Vault / Seafile / GitLab) for a project.
 * The URLs are computed server-side (the client bundle has no
 * `process.env`) and ride in the project-overview payload as
 * `serviceLinks`; a link is null unless its integration is
 * configured, so a Hub-only project simply shows fewer buttons.
 */

export type ProjectServiceLinks = {
  gitlab: string | null;
  vault: string | null;
  seafile: string | null;
};

const BTN =
  "inline-flex h-8 w-8 items-center justify-center rounded-md border border-input bg-background text-foreground hover:bg-accent transition-colors";

export function ProjectServiceButtons({ links }: { links: ProjectServiceLinks }) {
  if (!links.gitlab && !links.vault && !links.seafile) return null;

  return (
    <div className="flex items-center gap-2 shrink-0">
      {links.vault && (
        <a
          href={links.vault}
          target="_blank"
          rel="noopener noreferrer"
          title="Open project secrets in Vault"
          aria-label="Vault"
          className={BTN}
        >
          <img src="/service-logos/vault.svg" alt="" className="h-4 w-4 object-contain" />
        </a>
      )}
      {links.seafile && (
        <a
          href={links.seafile}
          target="_blank"
          rel="noopener noreferrer"
          title="Open project files in Seafile"
          aria-label="Seafile"
          className={BTN}
        >
          <Cloud className="h-4 w-4" />
        </a>
      )}
      {links.gitlab && (
        <a
          href={links.gitlab}
          target="_blank"
          rel="noopener noreferrer"
          title="Open in GitLab"
          aria-label="GitLab"
          className={BTN}
        >
          <img src="/service-logos/gitlab.svg" alt="" className="h-4 w-4 object-contain" />
        </a>
      )}
    </div>
  );
}
